export const isUnique = (code: string, array: { code: string }[]): boolean => {
  return !array.some((el) => el.code === code);
};
